import { useRef } from "react";
import HeroSection from "@/components/HeroSection";
import SocialProof from "@/components/SocialProof";
import ServiceHighlights from "@/components/ServiceHighlights";
import QuizFunnel from "@/components/QuizFunnel";
import MembershipPlans from "@/components/MembershipPlans";
import LeadCapture from "@/components/LeadCapture";
import FAQSection from "@/components/FAQSection";

export default function LandingPage() {
  const quizRef = useRef(null);
  const plansRef = useRef(null);
  const bookRef = useRef(null);

  const scrollToQuiz = () => {
    quizRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToPlans = () => {
    plansRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToBook = (plan) => {
    bookRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0A0A0B]">
      <HeroSection onStartQuiz={scrollToQuiz} onViewPlans={scrollToPlans} />
      <SocialProof />
      <ServiceHighlights />
      <div ref={quizRef}>
        <QuizFunnel onComplete={scrollToBook} />
      </div>
      <div ref={plansRef}>
        <MembershipPlans onSelect={scrollToBook} />
      </div>
      <div ref={bookRef}>
        <LeadCapture />
      </div>
      <FAQSection />
    </div>
  );
}
